import {IController, IModule} from "angular";
import {l} from "../../../types/typescriptdefinisjoner_lederplan";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('SystemMeldingKomponent');
const css = require('./systemMelding.scss');

export class SystemMeldingKomponent implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wkSystemMelding', {
                bindings: {
                    melding: '<'
                },
                controller: SystemMeldingKomponent.forInjisering(),
                template: require('./systemMelding.html'),
                transclude: true
            })
    }

    static forInjisering() {
        return [
            SystemMeldingKomponent
        ]
    }

    melding: l.SystemMeldingModell; //settes via bindings/$onChanges

}
